import { FC } from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

export interface PhoneInputProps {
    value?: string;
    onChange?: (value: string) => void;
    defaultCountry?: string;
    placeholder?: string;
    tabIndex?: number;
    required?: boolean;
    disabled?: boolean;
    name?: string;
    autoComplete?: string;
}

const PhoneInput: FC<PhoneInputProps> = ({
    value,
    onChange,
    defaultCountry = 'au',
    placeholder = 'Your Phone Number',
    tabIndex,
    required,
    disabled,
    name = 'phone',
    autoComplete = 'tel',
}) => {
    return (
        <ReactPhoneInput
            country={defaultCountry}
            value={value}
            onChange={(val) => onChange?.(val)}
            placeholder={placeholder}
            disabled={disabled}
            enableSearch
            containerClass="phone-input-container"
            inputClass="phone-input-field text-input"
            buttonClass="phone-input-button"
            dropdownClass="phone-input-dropdown"
            inputProps={{ required, tabIndex, name, autoComplete }}
        />
    );
};

export default PhoneInput;
